import { api_unsubscribe_from_weekly_digest_path } from '@routes';

import request from './request';

export interface UnsubscribeFromWeeklyDigestResponse {
  message: string;
}

export async function unsubscribeFromWeeklyDigest() {
  const resp = await request('post', api_unsubscribe_from_weekly_digest_path());
  return resp;
}
